import { Box, Grid, styled } from '@mui/material';

export const FilterContainer = styled(Grid)(({ theme }) => ({
  height: '90vh',
  overflowY: 'auto',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
}));

export const ActionsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  @media (max-width: 1300px) {
    flex-wrap: wrap;
  }
`;

export const LocationListPageHeader = styled(Grid)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: '10px',
});
